import { Routes, Route } from "react-router-dom";

import App from "./App";
import PodcastPage from "./PodcastPage/PodcastPage";
import PodcastExplorePage from "./PodcastPage/PodcastExplorePage";

import SpeakerProjectPage from "./views/SpeakerProjectPage";

import {
  useFirebaseApp,
  FirestoreProvider,
  FunctionsProvider,
} from "reactfire";
import { getFirestore } from "firebase/firestore";
import { getFunctions } from "firebase/functions";
import CompanyProjectPage from "./views/CompanyProjectPage";
import DonatePage from "./views/DonatePage";
import DonatePageHE from "./views/DonatePageHE";
import DonationSuccessPage from "./views/DonationSuccessPage";
import { Toaster } from "react-hot-toast";
import DonationSuccessPageHE from "./views/DonateSuccessPageHE";
import DonationSuccessPageStep2 from "./views/DonateSuccessPageStep2";
import DonationSuccessPageStep2HE from "./views/DonateSuccessPageStep2HE";
import PodcastRabbiPage from "./PodcastPage/PodcastRabbiPage";
import RabbiChannelPage from "./views/RabbiChannelPage";

const AllRoutes = () => {
  const firestoreInstance = getFirestore(useFirebaseApp());
  const firebaseFunctionsInstance = getFunctions(useFirebaseApp());

  return (
    <FirestoreProvider sdk={firestoreInstance}>
      <FunctionsProvider sdk={firebaseFunctionsInstance}>
        <Toaster />
        <Routes>
          <Route path="/" element={<App />} />
          <Route path="donate" element={<DonatePage />} />
          <Route path="donate-he" element={<DonatePageHE />} />
          <Route path="donate/success" element={<DonationSuccessPage />} />
          <Route
            path="donate/success/2"
            element={<DonationSuccessPageStep2 />}
          />
          <Route path="donate/success-he" element={<DonationSuccessPageHE />} />
          <Route
            path="donate/success-he/2"
            element={<DonationSuccessPageStep2HE />}
          />

          <Route path="podcast" element={<PodcastExplorePage />} />
          <Route path="podcast/:id" element={<PodcastPage />} />

          {/* speaker project */}
          <Route path="speaker/projects/:id" element={<SpeakerProjectPage />} />
          {/* speaker project */}

          {/* company project */}
          <Route path="company/projects/:id" element={<CompanyProjectPage />} />
          {/* company project */}

          <Route path=":channelId/podcast/:id" element={<PodcastRabbiPage />} />

          <Route path="channel/:channelId" element={<RabbiChannelPage />} /> 

        </Routes>
      </FunctionsProvider>
    </FirestoreProvider>
  );
};

export default AllRoutes;
